var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ins',{style:({
    display: 'block',
    width: '250px',
    border: '1px solid black',
    marginTop: '20px'
  }),attrs:{"className":"adsbygoogle2","data-ad-client":_vm.googleAdId,"data-ad-format":"auto","data-full-width-responsive":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }